// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__bC0it","clickable":"style_clickable__2IO+U","spin":"style_spin__YLNv4"};